import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Header from '../../../navigation/header/header.js';

import QuoteCreateForm from '../../../components/myquote/quote/quote-create-form.js';
import QuoteView from '../../../components/myquote/quote/quote-view.js';

class QuoteHomeScreen extends React.Component {
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;
		
		this.uuid = this.app.guid();
		
		this.state = {
			action: 'create',
			txhash: null,
			loaded: false,
			quoteinfo: 'loading...'
		};
	}
	
	// post render commit phase
	componentDidMount() {
		console.log('QuoteHomeScreen.componentDidMount called');
		let mvcmodule = this.getMvcModuleObject();
		
		mvcmodule.registerEventListener('on_refreshPage', this.uuid, this.onRefreshPage.bind(this));
		
		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}

	async checkNavigationState() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;



		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;


		if (app_nav_target && (app_nav_target.route == 'quote') && (app_nav_target.reached == false)) {
			var params = app_nav_target.params;

			if (params) {
				let txhash = params.txhash;
				let quoteinfo = '';
				let action = (params.action ? params.action : 'create');
	
				if (txhash) {
					// retrieve info from firenze
					quoteinfo = txhash;
				}
	
				this.setState({action, txhash, quoteinfo});
			}

			// QuoteView will take care of marking target reached
		}

		this.setState({loaded: true});
	}

	async onRefreshPage() {
		console.log('QuoteHomeScreen.onRefreshPage called');

		return this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	
	// end of life
	componentWillUnmount() {
		console.log('QuoteHomeScreen.componentWillUnmount called');
		let app = this.app;
		let mvcmodule = app.getMvcModuleObject();
		
		mvcmodule.unregisterEventListener('on_refreshPage', this.uuid);
	}
	
	
	render() {
		let {loaded, action, quoteinfo, txhash} = this.state;

		return (
			<div className="Screen">
				<Header app = {this.app} />
				{(loaded === true ?
				(action === 'view' ?
				<QuoteView app = {this.app} /> :
				<QuoteCreateForm app = {this.app} />) :
				<div>{quoteinfo}</div>
				)}
			</div>
		);
	}
}

// propTypes validation
QuoteHomeScreen.propTypes = {
	app: PropTypes.object.isRequired,
};



export default QuoteHomeScreen;